<template>
    <div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.leaveType.searchLeaveTypes')"
                        height="40px"
                        @keyup.enter="getLeaveTypePagination()"
                        solo>
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        color="primary"
                        outlined
                        height="40px"
                        @click="searchLeaveType()"
                        class="search-button">
                        {{ $vuetify.lang.t('$vuetify.leaveType.search') }}
                    </v-btn>
                </div>
            </div>
            <div>
                <v-btn
                    v-if="permissionCreate"
                    color="primary"
                    height="40px"
                    @click="createLeaveType()">
                    + {{ $vuetify.lang.t('$vuetify.leaveType.createLeaveType') }}
                    <!-- + Create LeaveType -->
                </v-btn>
            </div>
        </div>

        <leaveType-form-modal
            ref="leaveTypeModal"
            :mode="operationMode"
            :updateLeaveTypeId="updateLeaveTypeId"
            @success-created="updateLeaveTypesData()"
            @success-updated="updateLeaveTypesData()"
            @close-modal="closeModal()"/>

        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                :headers="headers"
                :items="formattedLeaveTypes"
                @page-count="pageCount = $event"
                :page.sync="page"
                :options.sync="options"
                :server-items-length="totalLeaveTypes"
                :loading="loading">
                <!-- <template v-slot:[`item.type`]="{ item }">
                    <div class="line">
                        <div>
                            {{ item.leave_type }}
                        </div>
                    </div>
                </template> -->
                <template v-slot:[`item.action`]="{ item }">
                        <div class="action">
                            <v-icon
                                v-if="permissionUpdate"
                                class="mr-2"
                                @click="updateLeaveTypeInfo(item)">
                                edit
                            </v-icon>
                            <v-icon
                                v-if="permissionDelete"
                                class="mr-2"
                                @click="openModalDelete(item)">
                                delete
                            </v-icon>
                        </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>

        <delete-modal
            ref="modalDeleteLeaveType"
            @success-deleted="deleteSuccess()"
            :deleteForm="deleteForm"/>

    </div>
</template>

<script>
import DeleteModal from '@/components/modal/DeleteModal'
import LeaveTypeFormModal from '@/components/modal/LeaveTypeFormModal.vue'
// import permissionConstant from '@/constants/permissions.js'
export default {
    name: 'LeaveTypeList',

    components: {
        LeaveTypeFormModal,
        DeleteModal
    },

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            leaveTypes: [],
            totalLeaveTypes: 0,
            loading: false,
            operationMode: '',
            updateLeaveTypeId: null,
            leaveTypeDeleteId: '',
            permissionCreate: true,
            permissionUpdate: true,
            permissionDelete: true,
            deleteForm: {
                header: '',
                content: '',
                path: ''
            }
        }
    },

    computed: {
        headers () {
            if (process.env.VUE_APP_TIGER_HR === 'true') {
                return [
                    { text: this.$vuetify.lang.t('$vuetify.leaveType.leaveType'), value: 'name', width: '20%' },
                    { text: 'ประเถทที่', value: 'type', width: '10%' },
                    { text: this.$vuetify.lang.t('$vuetify.leaveType.numberOfDays'), value: 'default_days', width: '10%' },
                    { text: '', value: 'action', width: '10%', sortable: false, align: 'end' }
                ]
            }
            return [
                { text: this.$vuetify.lang.t('$vuetify.leaveType.leaveType'), value: 'name', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.leaveType.numberOfDays'), value: 'default_days', width: '10%' },
                { text: '', value: 'action', width: '10%', sortable: false, align: 'end' }
            ]
        },
        formattedLeaveTypes () {
            return this.leaveTypes.map(leaveType => {
                const formattedDateMonth = `${leaveType.date}/${leaveType.month}`
                return { ...leaveType, dateMonth: formattedDateMonth }
            })
        }
    },

    methods: {
        // async getLeaveTypeList () {
        //     const res = await this.axios.get('leavetype/all')
        //     if (res && res.data && res.data.status === 'ok') {
        //         this.leaveTypes = res.data.data
        //     }
        // },

        createLeaveType () {
            this.operationMode = 'create'
            this.$refs.leaveTypeModal.dialog = true
        },

        updateLeaveTypeInfo (leaveType) {
            this.operationMode = 'update'
            this.updateLeaveTypeId = leaveType.id
            this.$refs.leaveTypeModal.dialog = true
        },

        async openModalDelete (leaveType) {
            this.leaveTypeDeleteId = leaveType.id
            this.deleteForm.header = this.$vuetify.lang.t('$vuetify.leaveType.deleteLeaveType')
            this.deleteForm.content = `${this.$vuetify.lang.t('$vuetify.leaveType.wantToDelete')} "${leaveType.name}" ?`
            this.deleteForm.path = `leavetype/delete/${leaveType.id}`
            this.$refs.modalDeleteLeaveType.dialog = true
        },

        async deleteSuccess () {
            await this.updateLeaveTypesData()
            if (this.leaveTypeDeleteId === localStorage.getItem('currentLeaveTypeId') && this.$store.state.leaveTypes) {
                this.$store.dispatch('setCurrentLeaveType', this.$store.state.leaveTypes[0])
            }
            this.$notify({
                title: this.$vuetify.lang.t('$vuetify.leaveType.congratulation'),
                text: this.$vuetify.lang.t('$vuetify.leaveType.leaveTypeIsDeleted'),
                type: 'success'
            })
        },

        async updateLeaveTypesData () {
            // await this.getLeaveTypeList()
            await this.getLeaveTypePagination()

            // update leaveType for leaveType selection component
            // await this.$store.dispatch('getLeaveTypes')
        },

        async searchLeaveType () {
            this.options.page = 1
            await this.getLeaveTypePagination()
        },

        async getLeaveTypePagination () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `leavetype?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.totalLeaveTypes = res.data.total
                this.leaveTypes = res.data.data
                this.loading = false
            }
        },

        closeModal () {
            this.operationMode = ''
        },

        checkPermission () {
            // this.permissionCreate = this.$util.checkPermission(permissionConstant.leaveType.create)
            // this.permissionUpdate = this.$util.checkPermission(permissionConstant.leaveType.update)
            // this.permissionDelete = this.$util.checkPermission(permissionConstant.leaveType.detele)
        }
    },

    mounted () {
        this.checkPermission()
    },

    watch: {
        options: {
            async handler () {
                // await this.getLeaveTypeList()
                await this.getLeaveTypePagination()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
    box-shadow: none !important;
    border: 1px solid #a8a8a8 !important;
}

.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
    font-size: 18px;
}

.search-container {
    width: 50%;
    display: flex;
    .search-input {
        width: 340px;
    }
    .search-button {
        height: 45px;
    }
}
</style>
